// extracted by mini-css-extract-plugin
module.exports = {"page_switch":"index--page_switch--3OAMO","page_switch__link":"index--page_switch__link--All9h","page_switch__link--active":"index--page_switch__link--active--3VyjX"};